
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/eagle-eye",
      function () {
        return require("private-next-pages/destinations/eagle-eye.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/eagle-eye"])
      });
    }
  